import {useRef,useCallback} from 'react'
import {debounce} from "lodash";

export function useDebounce(fn,delay=300){
    const fRef = useRef()
    fRef.current = fn
    const result = useCallback(debounce(()=>fRef.current(),delay),[])
    return result
}